import type { Paragraphs as ParagraphsType } from 'types/capi/content';

import Paragraph from './Paragraph';
import Text from './Text';

type Props = {
  collapsible?: boolean;
  paragraphs: ParagraphsType;
};

const Paragraphs = ({ paragraphs, collapsible }: Props) => {
  return (
    <div className="flex flex-col gap-5">
      {paragraphs.items?.map(({ content }, pIndex) => {
        return (
          <Paragraph collapsible={collapsible} key={`paragraph-${pIndex}`}>
            {content.items.map((item, index) => {
              return <Text key={`text-${index}`} item={item} />;
            })}
          </Paragraph>
        );
      })}
    </div>
  );
};

export default Paragraphs;
